export const competitionNameMap = new Map();

competitionNameMap.set('F1', 'Formula 1');